/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { AnyNonRedactedAutoTestStepAsJSON } from './AnyNonRedactedAutoTestStepAsJSON';
import { CheckPointsExtra } from './CheckPointsExtra';
const CheckPointsAsJSONParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(CheckPointsExtra, AnyNonRedactedAutoTestStepAsJSON);
export class CheckPointsAsJSON extends AnyNonRedactedAutoTestStepAsJSON {
    static decode(input) {
        return CheckPointsAsJSONParser.decode(input).map(res => new CheckPointsAsJSON(res));
    }
    static unsafeDecode(input) {
        return CheckPointsAsJSON.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CheckPointsAsJSONParser.encode(data);
    }
    static schema() {
        return CheckPointsAsJSONParser.schema();
    }
}
